var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"table","margin":"0 auto"},attrs:{"id":"app"}},[_c('div',{style:(_vm.part1)},[_c('router-view')],1),_c('div',{style:(_vm.part2)},[_c('TheFooter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }